export const CACHE_CONFIG = {
  TTL: 5 * 60 * 1000, // 5 minutes
  MAX_ITEMS: 100, // Nombre maximum d'items dans le cache
  PURGE_THRESHOLD: 0.8 // Purger quand 80% plein
};

export const PAGINATION_CONFIG = {
  ITEMS_PER_PAGE: 10,
  MAX_PAGES: 5 // Limite le nombre de pages qu'on peut charger
}; 